import React from "react";

export default function AboutSoloConnect() {
  return (
    <div className="w-full min-h-screen flex items-center justify-center bg-white pt-14">

      {/* ===================== DESKTOP (unchanged) ===================== */}
      <div
        className="hidden sm:block relative w-full overflow-hidden"
        style={{
          aspectRatio: "1280 / 686",
          backgroundImage: "url('/img/about-us/aboutbackground1.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Heading + description */}
      <div
  className="absolute"
  style={{ top: "7%", left: "4.5%", maxWidth: "34%" }}
>
  <h1 className="font-extrabold tracking-tight leading-[1.08]">
    <span className="block whitespace-nowrap text-black sm:text-[6vw] md:text-[4.2vw] lg:text-[4vw]">
      About
    </span>
    <span className="block whitespace-nowrap text-[#7209B7] sm:text-[6vw] md:text-[4.2vw] lg:text-[4vw]">
      SoloConnect
    </span>
  </h1>
  <p className="mt-4 text-[15px] md:text-base text-gray-600 leading-relaxed font-normal">
    SoloConnect is a travel companion platform designed to help solo
    travelers connect with like-minded people heading to the same
    destination on similar travel dates
  </p>
</div>

        {/* Dotted heart + plane doodle */}


        {/* Feature badges */}

      </div>

      {/* ===================== MOBILE (new) ===================== */}
      <div
        className="block sm:hidden relative w-full overflow-hidden"
        style={{
          aspectRatio: "390 / 760",
          backgroundImage: "url('/img/about-us/aboutbackgroundphone.svg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
  className="absolute left-1/2 -translate-x-1/2 text-center"
  style={{ top: "5%", width: "86%" }}
>
  <h1 className="font-extrabold tracking-tight leading-[1.08]">
    <span className="block whitespace-nowrap text-black text-[7vw]">
      About
    </span>
    <span className="block whitespace-nowrap text-[#7209B7] text-[7vw]">
      SoloConnect
    </span>
  </h1>
  <p className="mt-4 text-[15px] text-gray-600 leading-relaxed font-normal">
    SoloConnect is a travel companion platform designed to help solo
    travelers connect with like-minded people heading to the same
    destination on similar travel dates
  </p>
</div>
      </div>

    </div>
  );
}